/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarBlurbs_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbLeadTime_item" | "PdpRespSidebarBlurbShipping_item" | "PdpSharedBlurbDesignYourOwn_item" | "useShippingPrice_item">;
    readonly " $refType": "PdpRespSidebarBlurbs_item";
};
export type PdpRespSidebarBlurbs_item$data = PdpRespSidebarBlurbs_item;
export type PdpRespSidebarBlurbs_item$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbLeadTime_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbDesignYourOwn_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Literal",
          "name": "fetchShippingCostInfo",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "useShippingPrice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '9a11f3d696b440bdd2a7f45e40e8f350';
export default node;
